import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-3 col-sm-4" }
const _hoisted_3 = { class: "d-none d-md-block body-strong text-grey-900 text-start" }
const _hoisted_4 = { class: "d-block d-md-none body-strong text-grey-900 text-start" }
const _hoisted_5 = { class: "col-9 col-sm-8 d-flex flex-column-reverse flex-md-row flex-nowrap justify-content-end justify-content-sm-between" }
const _hoisted_6 = { class: "d-flex flex-row flex-nowrap justify-content-end" }

import { computed } from "vue";
import { useStore } from "vuex";
import Prices from "@/vue/planning/components/common/prices.vue";
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";
import PricesPP from "@/vue/planning/components/common/pricesPP.vue";
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";


export default /*@__PURE__*/_defineComponent({
  __name: 'total',
  setup(__props) {

const store = useStore();

const checkIfPerPersonDisplayWebsite = computed(() => {
	return ["www.uk.travelski.com","www.nl.travelski.com", "www.benl.yoonly.eu", "www.befr.yoonly.eu"].includes(getSiteFromDomain(window.location.hostname));
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(store).state.content.planner_resumeTotal), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(store).state.content.planner_resumeTotal), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(ParticipantsTotals, {
        participants: _unref(store).state.participants,
        content: _unref(store).state.content,
        additionalClasses: 'justify-content-end body-strong text-grey-900'
      }, null, 8, ["participants", "content"]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(checkIfPerPersonDisplayWebsite.value ? PricesPP : Prices), {
          isLoading: _unref(pricesLoadingSet).has(_unref(currentCacheKey)),
          crossedPrice: _unref(store).getters.totals.crossedPrice,
          totalPrice: _unref(store).getters.totals.totalPrice,
          perPrice: _unref(store).getters.totals.perPrice,
          maxPromo: _unref(store).getters.totals.maxPromo,
          locale: _unref(store).getters.locale,
          totalParticipants: _unref(store).state.participants.length
        }, null, 8, ["isLoading", "crossedPrice", "totalPrice", "perPrice", "maxPromo", "locale", "totalParticipants"]))
      ])
    ])
  ]))
}
}

})